import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ServiceUsageInfoDTO  {
    _originalTypeClassName = "zvelton_Backoffice.BO.ServiceUsageInfoDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ServiceUsageInfoDTO.translate = translateService;
}
this.totalTokens = null;
this.completionTokens = null;
this.promptTokens = null;
this.reasoningTokens = null;
this.promptTokensCached = null;
this.toolCalls = null;
this.ServiceUsageInfoDTOKey = null;
this._key = this.ServiceUsageInfoDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
totalTokens:any;
completionTokens:any;
promptTokens:any;
reasoningTokens:any;
promptTokensCached:any;
toolCalls:any;
private _ServiceUsageInfoDTOKey:any;
get ServiceUsageInfoDTOKey(): any {
    return this._ServiceUsageInfoDTOKey;
  }
set ServiceUsageInfoDTOKey(value: any) {
    this._ServiceUsageInfoDTOKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.ServiceUsageInfoDTOKey == null || $this.ServiceUsageInfoDTOKey == 0;
            }


}